module.exports = __webpack_public_path__ + "img/05k-Buy_Callidus03.d4927040.jpg";